import React from "react";
import CardDevice from "../../components/CardDevice";
import AlertComponent from "~/components/AlertComponent";
import { USER_LEVEL } from "../../configs/constants"

const DevicesComponent = ({
  devices,
  userLevel,
  onClick,
  onDelete,
  goAssign
}) => {
  return (
    <>        
      {devices.map((item, index) => (
        <CardDevice
          key={index}
          deviceId={item.deviceId}
          title={item.title}
          organizationName={item.organizationName}
          index={index}
          userLevel={userLevel}
          onClick={() => {
            onClick(item.deviceId);
          }}
          onDelete={() => {
            if (userLevel !== USER_LEVEL.establishment) {
              AlertComponent.dialog("Irá apagar todas as etiquetas e mídias exibidas neste dispositivo.",
                function dialoagNo() {
                },
                function dialoagYes() {
                  onDelete(item.deviceId);
                }    
              );    
            }         
          }}
          goAssign={() => {
            goAssign(item.deviceId);
          }}
        />
      ))}
    </>
  );
};

export default DevicesComponent;
